var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSectionDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.5 8C6.91667 8 7.27083 7.85417 7.5625 7.5625C7.85417 7.27083 8 6.91667 8 6.5C8 6.08333 7.85417 5.72917 7.5625 5.4375C7.27083 5.14583 6.91667 5 6.5 5C6.08333 5 5.72917 5.14583 5.4375 5.4375C5.14583 5.72917 5 6.08333 5 6.5C5 6.91667 5.14583 7.27083 5.4375 7.5625C5.72917 7.85417 6.08333 8 6.5 8V8M6.5 14.0208C8.15278 12.5347 9.39931 11.1667 10.2396 9.91667C11.0799 8.66667 11.5 7.54861 11.5 6.5625C11.5 5.10417 11.0243 3.89583 10.0729 2.9375C9.12153 1.97917 7.93056 1.5 6.5 1.5C5.06944 1.5 3.87847 1.97917 2.92708 2.9375C1.97569 3.89583 1.5 5.10417 1.5 6.5625C1.5 7.54861 1.92014 8.66667 2.76042 9.91667C3.60069 11.1667 4.84722 12.5347 6.5 14.0208V14.0208M6.5 16C4.31944 14.1806 2.69097 12.4896 1.61458 10.9271C0.538195 9.36458 0 7.90972 0 6.5625C0 4.70139 0.618055 3.14236 1.85417 1.88542C3.09028 0.628472 4.63889 0 6.5 0C8.34722 0 9.89236 0.628472 11.1354 1.88542C12.3785 3.14236 13 4.70139 13 6.5625C13 7.90972 12.4653 9.36111 11.3958 10.9167C10.3264 12.4722 8.69444 14.1667 6.5 16V16M6.5 6.5V6.5V6.5V6.5V6.5V6.5V6.5V6.5V6.5V6.5",
    fill: "#1D4ED8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionDocuments);
export default __webpack_public_path__ + "static/media/section-documents.6615aa7fafae00564a42e95f24d0018b.svg";
export { ForwardRef as ReactComponent };